import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ShieldOff } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { canAccess } from "@/lib/access";

export const RequireAccess = ({ children }) => {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const path = pathname.replace(/\/+$/, "");
  if (!user || canAccess(user, path)) return children;
  return (
    <div className="flex flex-col items-center justify-center py-24 text-center" data-testid="access-denied">
      <ShieldOff className="w-10 h-10 text-slate-400 mb-3" />
      <h2 className="text-lg font-semibold">You don't have access to this page</h2>
      <Button className="mt-4" onClick={() => navigate("/app")} data-testid="access-denied-dashboard-btn">Back to Dashboard</Button>
    </div>
  );
};
